import { render, staticRenderFns } from "./BackwardMinReleaseSchedules.vue?vue&type=template&id=65c1fb60&"
import script from "./BackwardMinReleaseSchedules.vue?vue&type=script&lang=js&"
export * from "./BackwardMinReleaseSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports